export default "__VITE_ASSET__BxO_UGZ8__"